import { Component, EventEmitter, Output } from "@angular/core";
import { tap } from "rxjs/operators";

import { RecaptchaApi } from "./recaptcha-api";

@Component({
  selector: "ta-recaptcha",
  template: `
    <ng-container *ngIf="siteKey$ | async as siteKey">
      <re-captcha
        (resolved)="resolved.emit($event)"
        [siteKey]="siteKey"
      ></re-captcha>
    </ng-container>
  `
})
export class RecaptchaComponent {
  @Output()
  resolved = new EventEmitter<string>();

  siteKey$ = this.recaptchaApi
    .getSiteKey()
    .pipe(tap(() => this.visible.emit(true)));

  @Output()
  visible = new EventEmitter<boolean>();

  constructor(private recaptchaApi: RecaptchaApi) {}
}
